import React from "react";
import PickMeals from "../Assets/pick-meals-image.png";
import ChooseMeals from "../Assets/choose-image.png";
import DeliveryMeals from "../Assets/delivery-image.png";

const Work = () => {
  const workInfoData = [
    {
      image: PickMeals,
      title: "Large game de produits",
      text: "Nous disposons de tous les produits de premiere necessités",
    },
    {
      image: ChooseMeals,
      title: "Facile à utiliser",
      text: "L´application Monmarche est tres intuitive et facile à utiliser. En quelques cliques, vous pouvez commander et recevoir votre facture automatiquement",
    },
    {
      image: DeliveryMeals,
      title: "Livraisons rapides",
      text: "Fini les longues files d'attente et les déplacements fatigants au marché. Nous livrons vos achats directement à votre porte.",
    },
  ];
  return (
    <div className="work-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">Avantages</p>
        <h1 className="primary-heading">Comment ça marche</h1>
        <p className="primary-text">
        Téléchargez dès maintenant "Monmarche" et découvrez la facilité et la commodité 
        du shopping en ligne pour vos besoins alimentaires quotidiens, 
        ainsi que pour toutes vos occasions spéciales. 
        Simplifiez votre vie et faites vos courses en toute simplicité avec "Monmarche" !
        </p>
      </div>
      <div className="work-section-bottom">
        {workInfoData.map((data) => (
          <div className="work-section-info" key={data.title}>
            <div className="info-boxes-img-container">
              <img src={data.image} alt="" />
            </div>
            <h2>{data.title}</h2>
            <p>{data.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Work;
